import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import { renderCanOemFileVehicle } from "shared/functions";
import { useApi } from "shared/hooks/useApi";
import { useIsMounted } from "shared/hooks/useIsMounted";
import { ENDPOINTS } from "shared/types/enums";

import SingleDataItem from "../../../SingleDataItem";
import { VehicleDataProps } from "../../types";
import Loader from "./Loader";

const VehicleData = ({ id }: VehicleDataProps) => {
    const { t } = useTranslation();
    const { getData, isCanceled } = useApi();
    const isMounted = useIsMounted();

    const [isLoading, setIsLoading] = useState(true);
    const [message, setMessage] = useState<string | null>(null);

    useEffect(() => {
        const getVehicleData = async () => {
            try {
                const { data } = await getData(`${ENDPOINTS.Vehicles}/${id}`);

                const canOemFileVehicle = renderCanOemFileVehicle(data, id, t);

                setMessage(canOemFileVehicle);
            } catch (error) {
                if (isMounted && !isCanceled(error)) {
                    const canOemFileVehicle = renderCanOemFileVehicle(
                        null,
                        id,
                        t
                    );

                    setMessage(canOemFileVehicle);
                }
            }

            setIsLoading(false);
        };

        getVehicleData();

        // eslint-disable-next-line
    }, []);

    return isLoading ? (
        <Loader />
    ) : (
        <SingleDataItem name={t("Attributes##vehicle")} data={message || "-"} />
    );
};

export default VehicleData;
